import React, { Component } from 'react';
import { Trans } from 'translations';
import Icon from 'components/icon';
import { connect } from 'react-redux';
import reduxUtils from 'util/redux';
import PropTypes from 'prop-types';
import FlipMove from 'react-flip-move';
import { breadcrumbsEasingFn, breadcrumbsSpeed } from 'constants/transitions-props';

const ANIMATION_OFFSET = -50;

class CategoryNavigationButton extends Component {
    static propTypes = {
        isCategorylistVisible: PropTypes.bool.isRequired,
        setCategoriesVisibility: PropTypes.func.isRequired,
        breadcrumbs: PropTypes.array.isRequired,
    };

    componentWillUpdate(nextProps) {
        const oldIsCategorylistVisible = this.props.isCategorylistVisible;
        const { isCategorylistVisible } = nextProps;

        if (oldIsCategorylistVisible !== isCategorylistVisible && isCategorylistVisible) {
            //window.scrollTo(0, 0);
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        }
    }

    onToggleClicked = () => {
        const { setCategoriesVisibility, isCategorylistVisible } = this.props;
        setCategoriesVisibility({ isVisible: !isCategorylistVisible });
    };

    get animations() {
        const defaultState = {
            transform: 'translateY(0px)',
            opacity: '',
        };

        return {
            in: {
                from: {
                    transform: `translateY(${ ANIMATION_OFFSET }px)`,
                },
                to: { ...defaultState },
            },

            out: {
                from: { ...defaultState },
                to: {
                    transform: `translateY(${ ANIMATION_OFFSET }px)`,
                },
            },
        };
    }

    render() {
        const { breadcrumbs, isCategorylistVisible } = this.props;
        const symbolName = isCategorylistVisible ? 'basket-remove' : 'basket-add';
        const translationPath = `category_menu.toggle.${ isCategorylistVisible ? 'close' : 'open' }`;

        return (
            <FlipMove
                duration={ breadcrumbsSpeed }
                easing={ breadcrumbsEasingFn }
                appearAnimation={ this.animations.in }
                enterAnimation={ this.animations.in }
                leaveAnimation={ this.animations.out }
                className="category-navigation-button"
            >
                { breadcrumbs.length === 0 &&

                <button className="category-navigation-button--btn" onClick={ this.onToggleClicked }>
                    <Trans path={ translationPath }/>
                    <Icon className="category-navigation-button--symbol" symbol={ symbolName } size="small"/>
                </button>
                }
            </FlipMove>
        );
    }
}


export default connect(
    reduxUtils.mapStateToProps({
        isCategorylistVisible: 'categories.isCategorylistVisible',
        breadcrumbs: 'breadcrumbs.items',
        isMobile: 'viewport.isMobile',
    }),
    reduxUtils.mapDispatchToProps({
        setCategoriesVisibility: 'categories.setCategoriesVisibility',
    }),
)(CategoryNavigationButton);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/category-navigation-button/index.js